export default __webpack_public_path__ + "static/media/AnimatedPlane.cacba6a2.gif";